import script from "./ElegibilityModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ElegibilityModal.vue?vue&type=script&setup=true&lang=js"

import "./ElegibilityModal.vue?vue&type=style&index=0&id=062b78dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-062b78dc"]])

export default __exports__